"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7038],{

/***/ 43231:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "z": function() { return /* binding */ Button; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);
/* harmony import */ var _spinner_Spinner__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(66641);
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(78707);




function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    var _arguments = arguments, _loop = function(i) {
        var source = _arguments[i] != null ? _arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    };
    for(var i = 1; i < arguments.length; i++)_loop(i);
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var DEFAULT_ELEMENT = "button";
var variants = {
    "filled-primary": "\n    bg-primary-green\n    text-black\n    ring-primary-green/25\n  ",
    "filled-neutral": "\n    bg-gray-100 active:bg-gray-200\n    text-black\n    border-gray-600 disabled:border-gray-600\n    ring-black/25\n  ",
    "light-positive": "\n    bg-pastel-green\n    text-mid-green\n    ring-mid-green/25\n  ",
    "light-negative": "\n    bg-pastel-pink\n    text-error\n    ring-error/25\n  ",
    "light-neutral": "\n    bg-gray-600/10\n    text-gray-600\n    ring-gray-600/25\n  ",
    "text-neutral": "\n    bg-transparent active:bg-gray-600/5\n    text-gray-600\n    ring-gray-600/25\n  ",
    "text-positive": "\n    bg-transparent active:bg-mid-green/5\n    text-mid-green\n    ring-mid-green/25\n  ",
    "text-negative": "\n    bg-transparent active:bg-error/5\n    text-error\n    ring-error/25\n  ",
    "text-dark": "\n    bg-transparent active:bg-gray-400/5\n    text-black\n    ring-black/25\n  ",
    "text-light": "\n    bg-transparent active:bg-gray-200/5\n    text-white\n    ring-white/25\n  "
};
var sizes = {
    xs: "gap-x-2 text-sm",
    sm: "min-h-[2rem] px-4 text-sm",
    md: "min-h-[3rem] px-8 text-base"
};
var Button = /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_1__.forwardRef(function(_param, ref) {
    var as = _param.as, children = _param.children, _type = _param.type, type = _type === void 0 ? "button" : _type, _variant = _param.variant, variant = _variant === void 0 ? "filled-primary" : _variant, _size = _param.size, size = _size === void 0 ? "md" : _size, startIcon = _param.startIcon, endIcon = _param.endIcon, isDisabled = _param.isDisabled, isLoading = _param.isLoading, className = _param.className, props = _objectWithoutProperties(_param, [
        "as",
        "children",
        "type",
        "variant",
        "size",
        "startIcon",
        "endIcon",
        "isDisabled",
        "isLoading",
        "className"
    ]);
    var Component = as || DEFAULT_ELEMENT;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(Component, _objectSpread({}, props, {
        ref: ref,
        type: type,
        disabled: isDisabled || isLoading,
        className: (0,_utils__WEBPACK_IMPORTED_MODULE_2__/* .cnm */ .w)("\n            inline-flex\n            select-none appearance-none\n            items-center justify-center gap-x-2\n            rounded-md border border-transparent font-medium\n            transition\n            focus:ring-4 focus-visible:outline-none\n\n            disabled:pointer-events-none\n            disabled:border-transparent\n            disabled:opacity-50\n          ", variants[variant], sizes[size], className),
        children: [
            isLoading && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_spinner_Spinner__WEBPACK_IMPORTED_MODULE_3__/* .Spinner */ .$, {
                size: "sm",
                className: "text-current"
            }),
            !isLoading && startIcon,
            children,
            !isLoading && endIcon
        ]
    }));
});



/***/ }),

/***/ 22315:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "y": function() { return /* binding */ useStyles; }
/* harmony export */ });
/* unused harmony export Input */
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);
/* harmony import */ var _mantine_core__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(10107);
/* harmony import */ var _releaseit_design_system__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(73903);
/* harmony import */ var _releaseit_design_system__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_releaseit_design_system__WEBPACK_IMPORTED_MODULE_2__);




function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _objectSpread(target) {
    var _arguments = arguments, _loop = function(i) {
        var source = _arguments[i] != null ? _arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    };
    for(var i = 1; i < arguments.length; i++)_loop(i);
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
var useStyles = (0,_mantine_core__WEBPACK_IMPORTED_MODULE_3__/* .createStyles */ .k)(function(theme, params, getRef) {
    var iconRef = getRef("icon");
    var multiSelectValueRef = getRef("multiSelectValue");
    return {
        root: {
            position: "relative",
            display: "flex",
            flexDirection: "column",
            isolation: "isolate"
        },
        input: _objectSpread(_defineProperty({
            fontFamily: _releaseit_design_system__WEBPACK_IMPORTED_MODULE_2__.tokens.FONTS.sans,
            fontSize: _releaseit_design_system__WEBPACK_IMPORTED_MODULE_2__.tokens.FONT_SIZES.base,
            borderColor: _releaseit_design_system__WEBPACK_IMPORTED_MODULE_2__.tokens.COLORS.gray[300],
            borderRadius: _releaseit_design_system__WEBPACK_IMPORTED_MODULE_2__.tokens.RADII.md,
            textOverflow: "ellipsis",
            transition: "all 0.15s ease-in-out",
            paddingLeft: 10,
            paddingRight: 10
        }, ".".concat(iconRef, " + &"), {
            paddingLeft: _releaseit_design_system__WEBPACK_IMPORTED_MODULE_2__.tokens.SPACING[10]
        }), params.label && {
            height: "auto",
            paddingTop: _releaseit_design_system__WEBPACK_IMPORTED_MODULE_2__.tokens.SPACING[5]
        }, params.hasFocus && {
            "&&:not(:disabled)": {
                color: "black",
                backgroundColor: "".concat(_releaseit_design_system__WEBPACK_IMPORTED_MODULE_2__.tokens.COLORS["primary-green"], "0d"),
                boxShadow: "0 0 0 4px ".concat(_releaseit_design_system__WEBPACK_IMPORTED_MODULE_2__.tokens.COLORS["primary-green"], "40")
            }
        }, params.error && {
            "&&:not(:disabled)": {
                color: "black",
                backgroundColor: "".concat(_releaseit_design_system__WEBPACK_IMPORTED_MODULE_2__.tokens.COLORS.error, "0d"),
                borderColor: _releaseit_design_system__WEBPACK_IMPORTED_MODULE_2__.tokens.COLORS.error,
                boxShadow: "0 0 0 4px ".concat(_releaseit_design_system__WEBPACK_IMPORTED_MODULE_2__.tokens.COLORS.error, "40")
            }
        }),
        label: _objectSpread({
            zIndex: 1,
            position: "absolute",
            pointerEvents: "none",
            paddingLeft: 11,
            paddingTop: 16,
            transition: "all 75ms ease-in-out",
            color: theme.colors.gray[6],
            fontFamily: _releaseit_design_system__WEBPACK_IMPORTED_MODULE_2__.tokens.FONTS.sans,
            fontSize: _releaseit_design_system__WEBPACK_IMPORTED_MODULE_2__.tokens.FONT_SIZES.base,
            fontWeight: _releaseit_design_system__WEBPACK_IMPORTED_MODULE_2__.tokens.FONT_WEIGHTS.medium
        }, (params.isActive || params.icon || params.placeholder) && {
            paddingTop: 6,
            fontSize: _releaseit_design_system__WEBPACK_IMPORTED_MODULE_2__.tokens.FONT_SIZES.xs,
            textTransform: "uppercase",
            color: _releaseit_design_system__WEBPACK_IMPORTED_MODULE_2__.tokens.COLORS.gray[800]
        }, params.disabled && {
            color: _releaseit_design_system__WEBPACK_IMPORTED_MODULE_2__.tokens.COLORS.gray[500]
        }, params.error && {
            color: _releaseit_design_system__WEBPACK_IMPORTED_MODULE_2__.tokens.COLORS.error
        }, _defineProperty({}, ".".concat(multiSelectValueRef, " &"), {
            fontFamily: _releaseit_design_system__WEBPACK_IMPORTED_MODULE_2__.tokens.FONTS.sans,
            color: _releaseit_design_system__WEBPACK_IMPORTED_MODULE_2__.tokens.COLORS.gray[800],
            lineHeight: 1.2,
            position: "unset",
            padding: "unset"
        })),
        description: _objectSpread({
            order: 1,
            marginTop: 7,
            marginBottom: -3,
            fontSize: "".concat(_releaseit_design_system__WEBPACK_IMPORTED_MODULE_2__.tokens.FONT_SIZES.sm, " !important")
        }, params.error && {
            display: "none"
        }),
        error: {
            order: 2,
            marginTop: 7,
            marginBottom: -3,
            lineHeight: 1.2
        },
        icon: _objectSpread({
            ref: iconRef,
            color: _releaseit_design_system__WEBPACK_IMPORTED_MODULE_2__.tokens.COLORS.gray[800],
            left: _releaseit_design_system__WEBPACK_IMPORTED_MODULE_2__.tokens.SPACING[1]
        }, params.label && {
            paddingTop: _releaseit_design_system__WEBPACK_IMPORTED_MODULE_2__.tokens.SPACING[6]
        }),
        value: {
            ref: multiSelectValueRef
        },
        hovered: {
            backgroundColor: theme.colors.gray[0]
        }
    };
});
function Input(_param) {
    var classNames = _param.classNames, props = _objectWithoutProperties(_param, [
        "classNames"
    ]);
    var ref2 = _slicedToArray(React.useState(false), 2), hasFocus = ref2[0], setHasFocus = ref2[1];
    var ref1 = _slicedToArray(React.useState(false), 2), hasValue = ref1[0], setHasValue = ref1[1];
    var isActive = hasFocus || hasValue;
    var classes = useStyles(_objectSpread({
        hasFocus: hasFocus,
        isActive: isActive
    }, props), {
        name: "Input",
        classNames: classNames
    }).classes;
    return /*#__PURE__*/ _jsx(MantineInput, _objectSpread({}, props, {
        onFocus: function onFocus(e) {
            var ref;
            setHasFocus(true);
            (ref = props.onFocus) === null || ref === void 0 ? void 0 : ref.call(props, e);
        },
        onBlur: function onBlur(e) {
            var ref;
            setHasFocus(false);
            (ref = props.onBlur) === null || ref === void 0 ? void 0 : ref.call(props, e);
        },
        onChange: function onChange(e) {
            var ref;
            setHasValue(!!e.target.value);
            (ref = props.onChange) === null || ref === void 0 ? void 0 : ref.call(props, e);
        },
        classNames: classes
    }));
}


/***/ }),

/***/ 66641:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$": function() { return /* binding */ Spinner; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(72779);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);


var sizes = {
    sm: "h-4 w-4",
    md: "h-6 w-6",
    lg: "h-12 w-12",
    xl: "h-24 w-24"
};
var variants = {
    light: "text-white",
    primary: "text-blue-600"
};
function Spinner(param) {
    var _size = param.size, size = _size === void 0 ? "md" : _size, _variant = param.variant, variant = _variant === void 0 ? "primary" : _variant, _className = param.className, className = _className === void 0 ? "" : _className;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
                className: classnames__WEBPACK_IMPORTED_MODULE_1___default()("animate-spin", sizes[size], variants[variant], className),
                xmlns: "http://www.w3.org/2000/svg",
                fill: "none",
                viewBox: "0 0 24 24",
                "data-testid": "loading",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("circle", {
                        className: "opacity-25",
                        cx: "12",
                        cy: "12",
                        r: "10",
                        stroke: "currentColor",
                        strokeWidth: "4"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                        className: "opacity-75",
                        fill: "currentColor",
                        d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                className: "sr-only",
                children: "Loading"
            })
        ]
    });
}


/***/ }),

/***/ 84868:
/***/ (function(__unused_webpack_module, exports) {


// Example palette (atlassian): https://atlassian.design/foundations/color
// Potential palette: https://accessiblepalette.com/?lightness=98.2,93.9,86,76,64,54,48,38,27,18&ff1122=0,0&ffa400=0,-10&00ff3f=0,0&589dff=0,0&c8cfde=0,0
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports.COLOR_ALIASES = exports.PALETTE = void 0;
// const PALETTE = {
//   transparent: "transparent",
//   current: "currentColor",
//   white: "#fff",
//   black: "#000",
//   neutral: {
//     50: "#f5f6f7", // (Off-white)
//     100: "#edeef0",
//     200: "#e4e5e7",
//     300: "#c9cfd9",
//     400: "#a1a8b6", // (Bluey-gray)
//     500: "#8f97a5",
//     600: "#767e8d",
//     700: "#606d80",
//     800: "#262b33",
//   },
//   green: {
//     50: "#f0fff5", // H 139 L 97%
//     100: "#e5ffed", // H 138 L 95% (Pastel-green)
//     200: "#ccffdb", // H 138 L 90%
//     500: "#00ff51", // H 139 L 50% (Primary-green)
//     600: "#00d544", // H 139 L 42% (Success)
//     700: "#00b339", // H 139 L 35% (Mid-green)
//   },
//   red: {
//     50: "#fff0f1", // H 356 L 97%
//     100: "#ffe6e8", // H 355 L 95% (Pastel-pink)
//     400: "#ff3b49", // H 356 L 62% (red)
//     500: "#ff1122", // H 356 L 53% (Error)
//   },
//   yellow: {
//     50: "#fffaf0", // H 39 L 97%
//     200: "#fff5cc", // H 48 L 90% (Pastel-yellow)
//     400: "#fdc40c", // H 46 L 52% (Yellow)
//     500: "#ffa400", // H 39 L 50% (Warning)
//   },
// ONLY USED FOR BANNER
//   orange: {
//     200: "#ffdfcc", // H 22 L 90% (Pastel-orange)
//     500: "#ff5e00", // H 22 L 50% (Orange)
//   },
// newYellow: {
//   '50': '#FFFAE5',
//   '100': '#FFF4CC',
//   '200': '#FFE599',
//   '300': '#FFD366',
//   '400': '#FFBD33',
//   '500': '#FFA400',
//   '600': '#CC7C00',
//   '700': '#995800',
//   '800': '#663700',
//   '900': '#331A00'
// }
//   blue: {
//     50: "#f0f6ff", // H 216 L 97%
//     100: "#deebff", // H 216 L 94% (Pastel-blue)
//     400: "#589dff", // H 215 L 67% (Blue)
//   },
// ONLY USED FOR BANNER
//   purple: {
//     100: "#e1e2ff", // H 238 L 94% (Pastel-purple)
//     400: "#696cff", // H 239 L 71% (Purple)
//   },
// // } as const;
// const BRAND_COLOR_ALIASES = {
//   "off-white": PALLETE.gray[50],
//   "primary-green": PALLETE.green[500],
//   "mid-green": PALLETE.green[700],
//   "pastel-green": PALLETE.green[100],
//   "brand-yellow": PALLETE.yellow[500],
//   "brand-orange": PALLETE.orange[500],
//   "brand-red": PALLETE.red[400],
//   "brand-pink": PALLETE.red[100],
//   "brand-purple": PALLETE.purple[400],
//   "brand-blue": PALLETE.blue[400],
//   "pastel-yellow": PALLETE.yellow[200],
//   "pastel-orange": PALLETE.orange[200],
//   "pastel-pink": PALLETE.red[100],
//   "pastel-purple": PALLETE.purple[100],
//   "pastel-blue": PALLETE.blue[100],
// } as const;
exports.PALETTE = {
    transparent: "transparent",
    current: "currentColor",
    white: "#fff",
    black: "#000",
    "off-white": "#f5f6f7",
    gray: {
        100: "#edeef0",
        200: "#e4e5e7",
        300: "#c9cfd9",
        400: "#a1a8b6",
        500: "#8f97a5",
        600: "#767e8d",
        700: "#606d80",
        800: "#262b33"
    },
    "primary-green": "#00ff51",
    red: "#ff3b49",
    pink: "#ff838b",
    orange: "#ff5e00",
    yellow: "#fdc40c",
    "mid-green": "#00b339",
    blue: "#589dff",
    purple: "#696cff",
    "pastel-pink": "#ffe6e8",
    "pastel-orange": "#ffdfcc",
    "pastel-yellow": "#fff5cc",
    "pastel-green": "#e5ffed",
    "pastel-blue": "#deebff",
    "pastel-purple": "#e1e2ff",
    success: "#00d544",
    error: "#ff1122",
    warning: "#ffa400"
};
exports.COLOR_ALIASES = {
    "hi-contrast": exports.PALETTE.black,
    "lo-contrast": exports.PALETTE.white,
    surface: exports.PALETTE.white,
    "active-link": exports.PALETTE["mid-green"],
    "secondary-link": exports.PALETTE.gray[400],
    disabled: exports.PALETTE.gray[300]
};


/***/ }),

/***/ 30239:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports.BREAKPOINTS = exports.ASPECT_RATIO = exports.SHADOWS = exports.RADII = exports.FONT_WEIGHTS = exports.FONT_SIZES = exports.FONTS = exports.SIZING = exports.SPACING = exports.COLORS = void 0;
var colors_1 = __webpack_require__(84868);
/**
 * Design tokens
 */ exports.COLORS = _objectSpread({}, colors_1.PALETTE, colors_1.COLOR_ALIASES);
exports.SPACING = {
    px: "1px",
    0: "0px",
    0.5: "0.125rem",
    1: "0.25rem",
    1.5: "0.375rem",
    2: "0.5rem",
    2.5: "0.625rem",
    3: "0.75rem",
    3.5: "0.875rem",
    4: "1rem",
    5: "1.25rem",
    6: "1.5rem",
    7: "1.75rem",
    8: "2rem",
    9: "2.25rem",
    10: "2.5rem",
    11: "2.75rem",
    12: "3rem",
    14: "3.5rem",
    16: "4rem",
    20: "5rem",
    24: "6rem",
    28: "7rem",
    32: "8rem",
    36: "9rem",
    40: "10rem",
    44: "11rem",
    48: "12rem",
    52: "13rem",
    56: "14rem",
    60: "15rem",
    64: "16rem",
    72: "18rem",
    80: "20rem",
    96: "24rem"
};
exports.SIZING = _objectSpread({}, exports.SPACING);
exports.FONTS = {
    sans: "Aeonik, system-ui, -apple-system, sans-serif",
    serif: "Georgia, Cambria, 'Times New Roman', Times, serif",
    mono: "Menlo, Monaco, Consolas, 'Liberation Mono', 'Courier New', monospace"
};
exports.FONT_SIZES = {
    xs: "0.75rem",
    sm: "0.875rem",
    base: "1rem",
    lg: "1.125rem",
    xl: "1.25rem",
    "2xl": "1.5rem",
    "3xl": "1.875rem",
    "4xl": "2.25rem",
    "5xl": "3rem",
    "6xl": "3.75rem"
};
exports.FONT_WEIGHTS = {
    normal: 400,
    medium: 500
};
exports.RADII = {
    none: "0",
    sm: "2px",
    md: "5px",
    lg: "10px",
    full: "9999px"
};
exports.SHADOWS = {
    sm: "0 2px 4px 0 rgba(0, 0, 0, 0.1)",
    lg: "0 8px 24px 0 rgba(51, 51, 51, 0.1), 0 8px 12px 0 rgba(0, 255, 81, 0.1)",
    card: "0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1)",
    none: "none"
};
exports.ASPECT_RATIO = {
    auto: "auto",
    square: "1 / 1",
    display: "4 / 3",
    video: "16 / 9"
};
exports.BREAKPOINTS = {
    sm: 640,
    md: 768,
    lg: 1024,
    xl: 1280
};


/***/ }),

/***/ 73903:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


var __createBinding = this && this.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
        desc = {
            enumerable: true,
            get: function get() {
                return m[k];
            }
        };
    }
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var __importStar = this && this.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    }
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports.tokens = void 0;
var tokens = __importStar(__webpack_require__(30239));
exports.tokens = tokens;


/***/ })

}]);